// const backendDomain = "http://192.168.1.246/oakya_cm_erp";
// const backendDomain = "https://oakyacmerp.oakyaitservices.in/api"
//const backendDomain = "http://192.168.1.23/ayusanjivani";
const backendDomain = "https://demo1.oakyaitservices.com/api";





// src/api/SummaryApi.js

const SummaryApi = {
  // ────────────────────────────────────────────────
  // Existing endpoints (you already had these)
  // ────────────────────────────────────────────────
  createAppointment: {
    url: `${backendDomain}/appointment/booking_create.php`,
    method: "POST",
  },

  

  // Optional – if you implement them later
  getAllAppointment: {
    url: `${backendDomain}/appointment/booking_retrieve.php`,
    method: "GET", // or GET with ?id=xxx
  },
  updateAppointment: {
    url: `${backendDomain}/appointment/appointment_update.php`,
    method: "POST",
  },
};

export default SummaryApi;